export default __webpack_public_path__ + "images/Y7.5b281db.png";